<template>
  <v-dialog v-model="app.showForgotPasswordDialog" max-width="600" class="overflow-visible" ref="forgotPasswordDialog">
    <v-card class="sigfloCard overflow-visible" :loading="app.authenticating" :disabled="app.authenticating">
      <v-card-text class="pb-8 overflow-visible">
        <v-avatar color="white" class="logoAvatar" width="56" height="56">
          <img src="@/assets/images/sigfloSymbolLogo.svg" alt="Sigflo" />
        </v-avatar>
      </v-card-text>
      <v-card-text class="pt-4">
        <div class="font-weight-light text-h4 text-darken-2 d-flex">
          <v-spacer />
          Reset Password
          <v-spacer />
        </div>
        <div class="px-12">Enter the email address you registered with to have a password reset email sent to you.</div>
        <div class="px-12 mt-12">
          <v-form ref="sentPasswordResetEmailForm" submit-prevent>
            <v-text-field
              autofocus
              label="Email"
              outlined
              filled
              v-model="email"
              required
              :rules="validation.email"
            ></v-text-field>
          </v-form>
          <div class="px-12 red-text">{{ error }}</div>
          <v-btn dark color="primary" block large @click="sendResetPasswordEmail">Reset Password</v-btn>
        </div>
        <div class="d-flex pt-4">
          <v-spacer />
          <div>
            Remember your password?
            <a href="#" @click="showLoginDialog">Log In</a>
          </div>
          <v-spacer />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        email: null,
        error: null
      };
    },
    computed: {
      ...mapState(['app'])
    },
    methods: {
      /**
       * Sends a reset password email.
       *
       * This method dispatches the 'resetPasswordRequest' action to the Vuex store,
       * passing the email as a parameter.
       */
      sendResetPasswordEmail() {
        if (this.$refs.sentPasswordResetEmailForm.validate()) {
          this.$store.dispatch('app/resetPasswordRequest', this.email).then((response) => {
            if (response.status === 200) {
              this.error = null;
              this.$store.dispatch('app/showSuccess', 'Password reset email sent to ' + this.email);
              this.$store.commit('app/setShowForgotPasswordDialog', false);
            } else {
              this.error = response;
            }
          });
        }
      }
    }
  };
</script>

<style>
  .v-dialog {
    overflow-y: visible !important;
  }
  .logoAvatar {
    position: absolute;
    top: -25px; /* Adjust as needed */
    left: 50%;
    transform: translateX(-50%);
  }
</style>
